import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from "@angular/forms";
import { NgbDate, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { Lightbox, LightboxConfig } from "ngx-lightbox";
import { environment } from "src/environments/environment";
import { RouterLink } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CurrencyPipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexPlotOptions,
  ApexLegend,
  ApexDataLabels,
  ApexTooltip,
} from "ng-apexcharts";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors: string[];
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  tooltip?: ApexTooltip;
};

@Component({
  selector: 'app-renew-management',
  templateUrl: './renew-management.component.html',
  styleUrls: ['./renew-management.component.scss']
})
export class RenewManagementComponent implements OnInit {
  constructor(
    private router: Router,
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private sanitizer: DomSanitizer
  ) { }
  name: "";
  terminalAddress: "";
  terminalBankAcc: "";
  terminalBankName: "";
  terminalBankAccountName: "";
  listBankname = [
    {
      name: "MB Bank",
      id: "970422",
    },
  ];
  id = JSON.parse(localStorage.getItem("currentUser")).id;
  userToken = JSON.parse(localStorage.getItem("currentUser")).user_token;
  searchTerm;
  listData = [];
  listData2 = [];
  listData3 = [];
  pageSize = 10;
  pageIndex = 1;
  totalCount = 0;
  tableName1 = "order-renew";
  tableName4 = "workspaces/device-and-bankaccount";
  role = JSON.parse(localStorage.getItem("currentUser"))["role"];
  submitted: boolean;
  formData: FormGroup;
  formData2: FormGroup;
  listType = ["Trưởng nhóm", "Phó cửa hàng", "Thành viên"];
  hoveredDate: NgbDate;
  fromNGDate: NgbDate;
  toNGDate: NgbDate;
  breadCrumbItems;
  hidden: boolean = true;
  listDataUser;

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  identifierRange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  get form() {
    return this.formData.controls;
  }

  private static readonly FILTER_STATE_KEY = "renewManagementFilterState";

  ngOnInit() {
    this.breadCrumbItems = [
      { label: "PAGE.HOME" },
      { label: "PAGE.REPORT.IncidentType", active: true },
    ];
    const restored = this.restoreFilterState();
    if (this.role === "admin" || this.role === "operation" || restored) {
      this.fetchData();
    }
    this.range.valueChanges.subscribe((rangeValues) => {
      const formatDate = (date: Date | null) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.filter.startDate = formatDate(rangeValues.start);
      this.filter.endDate = formatDate(rangeValues.end);
    });
  }

  public chartOptions: Partial<ChartOptions> | undefined;
  public amountChartOptions: Partial<ChartOptions> | undefined;
  totalRenewAmount = 0;
  totalRenewAmountFormatted = "";
  totalRenewCount = 0;
  totalRenewCountFormatted = "";

  invoicePdfUrl: SafeResourceUrl | null = null;
  previewInvoiceNo: string = '';

  previewInvoice(invoiceNo: string, modal: any) {
    if (!invoiceNo) return;
    this.previewInvoiceNo = invoiceNo;
    this.invoicePdfUrl = null;
    this.eventService.setLoading(true);
    this.apiService.getList(`electronic-invoice?invoiceNo=${invoiceNo}`).subscribe({
      next: (res: any) => {
        const fileToBytes = res?.metadata?.fileToBytes;
        if (fileToBytes) {
          const byteCharacters = atob(fileToBytes);
          const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
          const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          this.invoicePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.modalService.open(modal, { centered: true, size: 'xl', scrollable: true });
        } else {
          this.apiService.showToastMobile('error', this.translateService.instant('Không tìm thấy file hoá đơn'));
        }
        this.eventService.setLoading(false);
      },
      error: () => {
        this.apiService.showToastMobile('error', this.translateService.instant('Lỗi khi tải hoá đơn'));
        this.eventService.setLoading(false);
      }
    });
  }

  qrCodeValue: string;
  flagDownQr = false;
  deviceName;

  onEdit(data, content) {
    console.log(data);
    this.formData = this.makeForm(data);
    this.deviceName = data.serial_number;
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
    this.viewQRcode(data);
  }
  viewQRcode(dataQR) {
    this.qrCodeValue = dataQR.qr_string;
    this.flagDownQr = true;
  }
  isWebView() {
    const userAgent = navigator.userAgent;

    return (
      userAgent.indexOf("FBAN") > -1 ||
      userAgent.indexOf("FBAV") > -1 ||
      window.ReactNativeWebView ||
      userAgent.indexOf("wv") > -1 ||
      userAgent.indexOf("WebView") > -1 ||
      (userAgent.indexOf("Android") > -1 && userAgent.indexOf("wv") > -1)
    );
  }
  downloadQRCode() {
    const elementToDownload =
      document.querySelector(".qr-with-text").parentElement;

    if (elementToDownload) {
      html2canvas(elementToDownload as HTMLElement).then((canvas) => {
        const qrUrl = canvas.toDataURL("image/png");

        if (this.isWebView()) {
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({ action: "download", url: qrUrl })
            );
          }
        } else {
          const link = document.createElement("a");
          link.href = qrUrl;
          link.download = `QR_Code_${this.deviceName}.png`;
          link.click();
        }
      });
    } else {
      console.error("Không tìm thấy phần tử.");
    }
  }
  printQRCode() {
    // Lấy phần tử cần in
    const elementToPrint =
      document.querySelector(".qr-with-text")?.parentElement;

    if (!elementToPrint) {
      console.error("Không tìm thấy phần tử để in.");
      return;
    }

    html2canvas(elementToPrint).then((canvas) => {
      const qrUrl = canvas.toDataURL("image/png");

      const printWindow = window.open("", "_blank");
      printWindow?.document.write(`
          <html>
            <head>
              <title>In QR Code</title>
              <style>
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                  }
                  .print-container {
                    text-align: center;
                    width: 100%;
                    max-width: 450px; 
                  }
                  img {
                    width: 100%; 
                    height: auto;
                  }
                  @page {
                    margin: 0; /* Bỏ margin của trang */
                  }
                }
              </style>
            </head>
            <body>
              <div class="print-container">
                <img src="${qrUrl}" />
                <!-- Bỏ phần tên ở dưới -->
              </div>
            </body>
          </html>
        `);
      printWindow?.document.close();
      printWindow?.addEventListener("load", () => {
        printWindow?.print();
        printWindow?.close();
      });
    });
  }
  binNumber = "970422";
  accountNumber = "";
  bank_accountName = "";
  durationInfo: any;
  onInputBlur() {
    this.eventService.setLoading(true);

    const data = {
      partner_id: this.id,
      accountNumber: this.accountNumber,
      token: this.userToken,
    };

    this.http
      .post("https://paydee.tomotek.vn/prod/bank/account-info", data)
      .subscribe(
        (response: any) => {
          this.eventService.setLoading(false);
          if (
            response.ResponseData.errorCode === "200" &&
            !response.ResponseData.data
          ) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Không tìm thấy tài khoản")
            );
          } else if (response.ResponseData.data) {
            this.apiService.showToastMobile(
              this.translateService.instant("success"),
              this.translateService.instant("Tìm kiếm thành công")
            );
            this.bank_accountName = response.ResponseData.data.accountName;
            this.searching = true;
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(
                "Có lỗi xảy ra khi tìm kiếm tài khoản"
              )
            );
          }
        },
        (error) => {
          this.eventService.setLoading(false);
          console.error("Error occurred:", error);
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Lỗi kết nối. Vui lòng thử lại sau.")
          );
        }
      );
  }
  onChangePage(e) {
    this.pageIndex = e;
    this.fetchData();
  }

  viewDetail(data: any) {
    this.saveFilterState();
    this.router.navigate(["/renew-package/detail", data.order_renew_id]);
  }

  private saveFilterState() {
    const state = {
      filter: this.filter,
      params: this.params,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      searching: this.searching,
    };
    sessionStorage.setItem(
      RenewManagementComponent.FILTER_STATE_KEY,
      JSON.stringify(state)
    );
  }

  private restoreFilterState(): boolean {
    const raw = sessionStorage.getItem(RenewManagementComponent.FILTER_STATE_KEY);
    if (!raw) {
      return false;
    }
    sessionStorage.removeItem(RenewManagementComponent.FILTER_STATE_KEY);
    try {
      const state = JSON.parse(raw);
      this.filter = { ...this.filter, ...(state.filter || {}) };
      this.params = state.params || "";
      this.pageIndex = state.pageIndex || 1;
      this.pageSize = state.pageSize || 10;
      this.searching = !!state.searching;
      if (this.filter.startDate || this.filter.endDate) {
        this.range.patchValue(
          {
            start: this.filter.startDate ? new Date(this.filter.startDate) : null,
            end: this.filter.endDate ? new Date(this.filter.endDate) : null,
          },
          { emitEvent: false }
        );
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  canCreateClaim(data: any): boolean {
    return !data?.order_claim_id;
  }

  selectedRenewData: any = null;
  submittedClaim = false;
  formClaim: FormGroup;

  openClaimModal(data: any, content: any) {
    this.selectedRenewData = data;
    this.submittedClaim = false;
    this.formClaim = this.formBuilder.group({
      claimDate: [null, [Validators.required]],
      claimReason: ["", [Validators.required]],
    });
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  submitClaim() {
    this.submittedClaim = true;
    if (this.formClaim.invalid) {
      return;
    }
    const formattedDate = this.formatLocalDate(this.formClaim.value.claimDate);
    this.eventService.setLoading(true);
    this.apiService
      .postItem(`order-renew/claim`, {
        orderRenewId: this.selectedRenewData.order_renew_id,
        claimDate: formattedDate,
        claimReason: this.formClaim.value.claimReason,
      })
      .subscribe({
        next: () => {
          this.eventService.setLoading(false);
          this.modalService.dismissAll();
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Ghi nhận claim thành công")
          );
          this.fetchData();
        },
        error: (err) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.getErrorMessage(err) ||
              this.translateService.instant("Ghi nhận claim thất bại")
          );
        },
      });
  }

  private getErrorMessage(err: any): string {
    if (!err) {
      return null;
    }
    if (typeof err === "string") {
      return err;
    }
    return err?.error?.message || err?.message || null;
  }

  private formatLocalDate(dateStr: string): string {
    if (!dateStr) {
      return null;
    }
    const d = new Date(dateStr);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  clearDate() {
    this.selected = "";
    this.filter.startDate = "";
    this.filter.endDate = "";
  }

  filter: { [key: string]: string } = {
    phone: "",
    startDate: "",
    endDate: "",
    terminal_bank_acc: "",
    original_duration: "",
    invoice_no: "",
    renew_type: "",
    serial_number: "",
    mb_reference_number: "",
    invoice_status: "",
  };
  searching = false;

  params = "";
  submitFilter() {
    if (this.filter.original_duration == null) {
      this.filter.original_duration = '';
    }
    if (this.filter.invoice_status == null) {
      this.filter.invoice_status = '';
    }
    this.params = "";
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        this.params += `&${key}=${this.filter[key]}`;
      }
    });

    if (this.params || this.role === 'admin' || this.role === 'operation') {
      this.pageIndex = 1;
      this.searching = true;
      this.fetchData();
    }
  }
  selected: any;

  clearFilter() {
    this.selected = "";
    this.params = "";
    this.filter.phone = "";
    this.filter.serial_number = "";
    this.filter.startDate = "";
    this.filter.endDate = "";
    this.filter.terminal_bank_acc = "";
    this.filter.original_duration = "";
    this.filter.invoice_status = "";
    this.pageIndex = 1;
    this.range.reset();
    this.identifierRange.reset();

    if (this.role === "admin" || this.role === "operation") {
      this.fetchData();
      return;
    }

    // Other roles require at least one search criterion, so clearing
    // filters can't re-fetch — just reset the table to its empty state.
    this.searching = false;
    this.listData = [];
    this.totalCount = 0;
    this.chartOptions = undefined;
    this.amountChartOptions = undefined;
    this.totalRenewAmount = 0;
    this.totalRenewAmountFormatted = "";
    this.totalRenewCount = 0;
    this.totalRenewCountFormatted = "";
  }

  fetchData() {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableName1 +
        `?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          this.listData = res["metadata"]["results"]
            ? res["metadata"]["results"]
            : [];
          this.totalCount = res?.metadata?.pagination?.totalCount || 0;

          const totals = res?.metadata?.total_transactions;
          if (totals) {
            this.totalRenewCount = +(totals.total || 0);
            this.totalRenewCountFormatted =
              this.totalRenewCount.toLocaleString("vi-VN");
            this.chartOptions = {
              series: [totals.total_manual || 0, totals.total_autodebit || 0],
              chart: { type: "donut", height: 220 },
              labels: [
                `Thủ công (${(totals.total_manual || 0).toLocaleString("vi-VN")})`,
                `Tự động (${(totals.total_autodebit || 0).toLocaleString("vi-VN")})`,
              ],
              colors: ["#6b7280", "#22c55e"],
              legend: { position: "bottom" },
              dataLabels: { enabled: true },
              tooltip: {
                y: {
                  formatter: (val) => Number(val).toLocaleString("vi-VN"),
                  title: {
                    formatter: () => "",
                  },
                },
              },
            };
          }

          const priceStats = res?.metadata?.discounted_price_stats;
          this.totalRenewAmount = +(res?.metadata?.total_amount || 0);
          this.totalRenewAmountFormatted =
            this.totalRenewAmount.toLocaleString("vi-VN") + "đ";
          if (priceStats && priceStats.length) {
            this.amountChartOptions = {
              series: priceStats.map((p) => +p.total_amount || 0),
              chart: { type: "donut", height: 220 },
              labels: priceStats.map(
                (p) =>
                  `${(+p.discounted_price).toLocaleString("vi-VN")}đ (${(+p.count || 0).toLocaleString("vi-VN")})`
              ),
              colors: priceStats.map((p: any) =>
                +p.discounted_price >= 395000 ? "#fcb92c" : "#1cbb8c"
              ),
              legend: { position: "bottom" },
              dataLabels: {
                enabled: true,
                formatter: (val) => Number(val).toFixed(1) + "%",
              },
              tooltip: {
                y: {
                  formatter: (val) => Number(val).toLocaleString("vi-VN") + "đ",
                  title: {
                    formatter: () => "",
                  },
                },
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: "65%",
                    labels: {
                      show: false,
                      value: {
                        formatter: (val) =>
                          Number(val).toLocaleString("vi-VN") + "đ",
                      },
                      total: {
                        show: false,
                      },
                    },
                  },
                },
              },
            };
          }

          this.eventService.setLoading(false);
        },
        error: (err) => {
          this.eventService.setLoading(false);
          this.apiService.showToastMobile(
            "error",
            this.getErrorMessage(err) ||
              this.translateService.instant("Không tải được danh sách giao dịch gia hạn")
          );
        },
      });
  }

  list_serial_number = [];

  list_id_account = [];


  logDateRange(start: Date | null, end: Date | null) {
    console.log("Start date:", start);
    console.log("End date:", end);
  }

  addLang() {
    const language = this.form.language as FormArray;
    let lang = this.makePrice();
    language.push(lang);
  }

  removeLang(i) {
    const language = this.form.language as FormArray;
    language.removeAt(i);
  }

  openModal(content: any) {
    this.submitted = false;
    this.formData = this.makeForm({ language: [{}] });
    let a = this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  openModalLink(contentLink) {
    this.submitted = false;
    this.formData2 = this.makeForm2({ language: [{}] });
    let a = this.modalService.open(contentLink, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  selectedIncident = null;
  selectedKeyword = null;

  makeFormKeyword(d) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      name: [data.name],
      incident_type_id: [data.incident_type_id],
    });
  }

  fetchKeyword() {
    this.dataKeyword = [];
    this.eventService.setLoading(true);
    this.apiService
      .getList(`keyword?type_id=${this.selectedIncident.id}`)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.dataKeyword = [...res];
          this.eventService.setLoading(false);
        },
      });
  }

  dataKeyword = [];

  formEditKeyword: FormGroup;
  formNewKeyword: FormGroup;
  editKeyword(data, index) {
    this.formEditKeyword = this.makeFormKeyword(data);
    this.selectedKeyword = data;
  }

  onSubmitFormKeyword(type) {
    if (type == 1) {
      if (this.formEditKeyword.valid) {
        const value = this.formEditKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.editItem("keyword", value.id, value).subscribe({
          next: (res) => {
            this.selectedKeyword = null;
            this.fetchKeyword();
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      if (this.formNewKeyword.valid) {
        const value = this.formNewKeyword.value;
        this.eventService.setLoading(true);
        this.apiService.addItem("keyword", value).subscribe({
          next: (res) => {
            this.eventService.setLoading(false);
            this.formNewKeyword.reset({
              incident_type_id: this.selectedIncident.id,
            });
            this.fetchKeyword();
          },
        });
      }
    }
  }

  onOpenKeywordModal(content, incident) {
    this.selectedIncident = incident;
    this.fetchKeyword();
    this.formNewKeyword = this.makeFormKeyword({
      incident_type_id: this.selectedIncident.id,
    });
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  defaultPrices = [
    { condition: 1, price: 0, unit: "" },
    { condition: 2, price: 0, unit: "" },
  ];

  onDeleteKeyword(id) {
    if (id) {
      this.eventService.setLoading(true);
      this.apiService.deleteItem("keyword", id).subscribe((res) => {
        Swal.fire(
          this.translateService.instant("FORM.Success"),
          this.translateService.instant("FORM.SuccessMessageDelete"),
          "success"
        ).then((res) => {
          this.fetchKeyword();
        });
        this.eventService.setLoading(false);
      });
    }
  }

  onDelete(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant("FORM.WarningMessage"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        this.apiService.deleteItem(this.tableName1, data).subscribe((res) =>
          Swal.fire(
            this.translateService.instant("FORM.Success"),
            this.translateService.instant("FORM.SuccessMessageDelete"),
            "success"
          ).then((res) => {
            this.fetchData();
          })
        );
      }
    });
  }

  makeForm(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      quantity: [data.quantity, [Validators.required]],
    });
  }

  makeForm2(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      // id: [data.id],
      // imei : [data.imei, [Validators.required]],
      // description: [data.description],
      // price: [data.price || 0, [Validators.required]],
      // model : [data.model, [Validators.required]],
      // image_url: [data.image_url, [Validators.required]],
      device_id: [data.device_id, [Validators.required]],
      bankaccount_id: [data.bankaccount_id, [Validators.required]],
      // type: [data.type, [Validators.required]],
      // currency: [data.currency || 'VND'],
    });
  }

  makePrices(data = []) {
    let arr = new FormArray([]);
    data.forEach((i) => {
      arr.push(this.makePrice(i));
    });
    return arr;
  }

  viewDetails(data: any) {
    this.router.navigate(["/workspaces/detail-workspace", data.id]);
  }

  makePrice(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      key: [data.key, [Validators.required]],
      // price: [data.price, [Validators.required, Validators.min(0)]],
      value: [data.value, [Validators.required]],
      // id: [data.id]
    });
  }

  uploadedImage;

  saveData() {
    this.submitted = true;
    if (this.formData.valid) {
      const value = this.formData.value;
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName1, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData.reset();
            this.fetchData();
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem("terminal-qr", value).subscribe({
          next: (res) => {
            this.fetchData();
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "success",
              title: this.translateService.instant("FORM.Success"),
            });

            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "error",
              title: this.translateService.instant("FORM.ErrorMessageAdd"),
            });
            this.eventService.setLoading(false);
            // this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.userNotExist'), 'error')
            // this.eventService.setLoading(false)
          },
        });
      }
    } else {
      console.log("invalid", this.formData);
      Object.values(this.formData.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  saveData2() {
    this.submitted = true;
    if (this.formData2.valid) {
      const value = this.formData2.value;
      // value['status'] = value['status'] == true ? 0 : 1
      // value['prices'][0]['condition'] = 1
      // value['prices'][1]['condition'] = 2
      // value['price']= value['prices']
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName4, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData2.reset();
            // this.fetchData2()
            // this.fetchData3()
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("FORM.ErrorMessage"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem("this.tableName4", value).subscribe({
          next: (res) => {
            // this.fetchData2()
            // this.fetchData3()
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "success",
              title: this.translateService.instant("FORM.Success"),
            });

            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "error",
              title: this.translateService.instant("FORM.ErrorMessageAdd"),
            });
            this.eventService.setLoading(false);
            // this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.userNotExist'), 'error')
            // this.eventService.setLoading(false)
          },
        });
      }
    } else {
      console.log("invalid", this.formData2);
      Object.values(this.formData2.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  isInside(date: NgbDate) {
    return date.after(this.fromNGDate) && date.before(this.toNGDate);
  }
  isHovered(date: NgbDate) {
    return (
      this.fromNGDate &&
      !this.toNGDate &&
      this.hoveredDate &&
      date.after(this.fromNGDate) &&
      date.before(this.hoveredDate)
    );
  }
  /**
   * @param date date obj
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromNGDate) ||
      date.equals(this.toNGDate) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
}
